module.exports = __webpack_public_path__ + "img/noticia-21.e0e89d03.jpg";